import { render, staticRenderFns } from "./Community-impact.vue?vue&type=template&id=51633aaa&scoped=true&"
import script from "./Community-impact.vue?vue&type=script&lang=js&"
export * from "./Community-impact.vue?vue&type=script&lang=js&"
import style0 from "./Community-impact.vue?vue&type=style&index=0&id=51633aaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51633aaa",
  null
  
)

export default component.exports